import * as React from 'react';

export function TableCompanionsIcon({ value }: { value: Nullable<number> }) {
	return value ? <>{value}&times;<i className='fa fa-male'></i></> : null;
}